import { render, staticRenderFns } from "./ParametrosGr.vue?vue&type=template&id=60f3f29c&scoped=true&"
import script from "./ParametrosGr.vue?vue&type=script&lang=js&"
export * from "./ParametrosGr.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosGr.vue?vue&type=style&index=0&id=60f3f29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3f29c",
  null
  
)

export default component.exports